"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
__exportStar(require("./affordable-clean-energy.icon"), exports);
__exportStar(require("./cleaner-water-sanitation.icon"), exports);
__exportStar(require("./climate-action.icon"), exports);
__exportStar(require("./decent-work-economic-growth.icon"), exports);
__exportStar(require("./gender-equality.icon"), exports);
__exportStar(require("./good-health-and-wellbeing.icon"), exports);
__exportStar(require("./industry-innovation-infrastructure.icon"), exports);
__exportStar(require("./life-below-water.icon"), exports);
__exportStar(require("./life-on-land.icon"), exports);
__exportStar(require("./no-poverty.icon"), exports);
__exportStar(require("./partnerships.icon"), exports);
__exportStar(require("./peace-justice-strong-institutions.icon"), exports);
__exportStar(require("./quality-education.icon"), exports);
__exportStar(require("./reduced-inequalities.icon"), exports);
__exportStar(require("./responsible-consumption-and-production.icon"), exports);
__exportStar(require("./sustainable-cities-communities.icon"), exports);
__exportStar(require("./zero-hunger.icon"), exports);